import { Component, EventEmitter, OnInit, Input, Output, AfterContentChecked, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Genders } from 'src/app/constants/genders';
import { MaskType } from 'src/app/constants/masks';
import { Dependent } from 'src/app/models/dependent';
import { ListItem } from 'src/app/models/listItem';
import { FormValidationService } from 'src/app/services/form-validation.service';
import { HelperService } from 'src/app/services/helper.service';
import { LookupService } from 'src/app/services/lookup.service';

@Component({
    selector: 'mwp-dependent-form',
    templateUrl: './dependent-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DependentFormComponent implements OnInit, AfterContentChecked {
    @Input() public isNewDependent: boolean;
    @Input() public dependent: Dependent;
    @Input() public isChangeSaveToContinue: boolean;
    @Output() public emitContinueForm: EventEmitter<Dependent> = new EventEmitter<Dependent>();
    @Output() public emitDependent: EventEmitter<Dependent> = new EventEmitter<Dependent>();
    @Output() public emitClose: EventEmitter<any> = new EventEmitter();

    public maskType = MaskType;
    public genders = Genders;
    public dependentForm: FormGroup;
    public displayForm: boolean;
    public suffixes: ListItem[];
    public relationships: ListItem[];
    public isContinueButton: boolean;

    constructor(
        private formBuilder: FormBuilder,
        private lookupService: LookupService,
        private helperService: HelperService,
    ){
    }

    ngOnInit(): void {
        this.lookupService.getSuffix().subscribe((response: ListItem[]) => {
            this.suffixes = response;
        }); 

        this.lookupService.getRelationships().subscribe((response: ListItem[]) => {
            this.relationships = response;
        });

        this.buildForm();
    }

    ngAfterContentChecked() {
        if (this.dependentForm && 
            this.dependentForm.get('id').value != this.dependent.id)
            this.buildForm();
    }

    private buildForm(): void {
        this.dependentForm = this.formBuilder.group({
            id: [this.dependent.id],
            firstName: [this.dependent.firstName, [Validators.required]],
            middleName: [this.dependent.middleName],
            lastName: [this.dependent.lastName, [Validators.required]],
            suffix: [this.dependent.suffix],
            dependentAge: [this.dependent.dependentAge],
            dependentSsn: [this.dependent.dependentSsn],
            dependentGender: [this.dependent.dependentGender, [Validators.required]],
            dependentDateOfBirth: [this.dependent.dependentDateOfBirth, [Validators.required, Validators.compose([FormValidationService.validMaterialDate(true)])]],
            dependentRelationship: [this.dependent.dependentRelationship, [Validators.required]],
        });

        if (this.isChangeSaveToContinue && this.dependent.dependentDateOfBirth) {
            this.isContinueButton = this.tobaccoAgeCheck(this.dependent.dependentDateOfBirth);
        }
    }

    private tobaccoAgeCheck(dobDate: any): boolean {
        const l_AgeCheck = new Date();
        l_AgeCheck.setFullYear(l_AgeCheck.getFullYear() - 18);
        return dobDate <= l_AgeCheck;
    }

    public submitForm(): void {
        this.dependent = this.helperService.convertObjectIntoObject(this.dependentForm.value, this.dependent);
        
        if (this.isContinueButton)
            this.emitContinueForm.emit(this.dependentForm.value);
        else
            this.emitDependent.emit(this.dependentForm.value);
    }

    public close(): void {
        this.emitClose.emit();
    }
}